export default __webpack_public_path__ + "static/media/laundry1-beforeA-480w.8aaf0853.png";